import { useState, useEffect } from "react";
import LoginDropdown from "./LoginDropdown";

export const menuItems = [
  { label: "Estruturas", href: "#estruturas" },
  { label: "Serviços", href: "#servicos" },
  { label: "Nossa história", href: "#historia" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  // Trava a rolagem e fecha com Esc enquanto o menu do celular está aberto
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    if (!menuOpen) return;
    const onKey = (e) => e.key === "Escape" && setMenuOpen(false);
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [menuOpen]);

  // Ao girar o tablet para paisagem o menu do celular some; fecha para destravar a rolagem
  useEffect(() => {
    const desktop = window.matchMedia("(min-width: 900px)");
    const close = (e) => e.matches && setMenuOpen(false);
    desktop.addEventListener("change", close);
    return () => desktop.removeEventListener("change", close);
  }, []);

  return (
    <header className="nav" data-open={menuOpen}>
      <div className="nav-bar">
        <a href="#inicio" className="nav-logo" aria-label="FinTrust Investimentos, início">
          <img src="/logo-dark.png" alt="FinTrust" width="3277" height="1171" />
        </a>

        <nav className="nav-links" aria-label="Principal">
          {menuItems.map((item) => (
            <a key={item.href} href={item.href}>
              {item.label}
            </a>
          ))}
        </nav>

        <div className="nav-end">
          <LoginDropdown />
          <a href="#contato" className="btn btn-sm">
            Fale conosco
          </a>
        </div>

        <button
          type="button"
          className="nav-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-expanded={menuOpen}
          aria-controls="nav-sheet"
          aria-label={menuOpen ? "Fechar menu" : "Abrir menu"}
        >
          <span />
          <span />
        </button>
      </div>

      <div id="nav-sheet" className="nav-sheet" hidden={!menuOpen}>
        <ul>
          {[...menuItems, { label: "Contato", href: "#contato" }].map((item, i) => (
            <li key={item.href} style={{ "--i": i }}>
              <a href={item.href} onClick={() => setMenuOpen(false)}>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
        <LoginDropdown />
      </div>
    </header>
  );
}
